<div class="max-width-p">
  <app-notification-banner></app-notification-banner>
  <!-- HEADER -->
  <benefit-header-summary
    headerText="{{flexibleBenefit?.name}}"
    [offeredBy]=flexibleBenefit?.providerName
    smallText="{{
      'FLEXIBLE_FIXED_BENEFITS.FLEXIBLE_BENEFITS_SMALL_TEXT' | translate
    }}"
  >
  </benefit-header-summary>

  <div class="budget benefit-name" *ngIf="benefitPhotos && flexibleBenefit">
    <div class="left-content">
      <div class="c-body">
        <div class="benefit-details mb-1">
          <img
            [src]="benefitPhotos[0].pictureUrl"
            alt="" role="presentation"
            class="img"
            *ngIf="benefitPhotos[0]"
          />
          <div class="text">
            <div class="bold">{{ flexibleBenefit?.name }}</div>
            <div class="d-block">
              {{ 'FLEXIBLE_FIXED_BENEFITS.TEXT.OFFERED_BY' | translate }}
              <span class="semi-bold fs-12">
                {{ flexibleBenefit?.providerName }}
              </span>
            </div>
            <div class="d-block mt-1" *ngIf="activeEventName && !isEventLimitConsumed && !isVerifyingOrder">
              <span class="badge badge-light-warning font-small-3" style="white-space: normal; word-break: break-word; text-align: left;">
                {{ 'FLEXIBLE_FIXED_BENEFITS.PART_OF_EVENT' | translate: { eventName: activeEventName } }}
              </span>
            </div>
          </div>
        </div>
        <div class="images d-flex" *ngIf="benefitPhotos.length > 1">
          <img
            *ngIf="benefitPhotos[1]"
            [src]="benefitPhotos[1].pictureUrl"
            class="img"
          />
          <img
            *ngIf="benefitPhotos[2]"
            [src]="benefitPhotos[2].pictureUrl"
            class="img"
          />
          <img
            *ngIf="benefitPhotos[3]"
            [src]="benefitPhotos[3].pictureUrl"
            class="img"
          />
        </div>
        <div class="text">
          <p class="benefit-description" [innerHtml]="flexibleBenefit?.description | sanitizeHtml"></p>
        </div>
      </div>

      <app-benefit-availability *ngIf="flexibleBenefit.categoryId == '6'"
                                [benefitId]="benefitId"
                                [companyId]="companyId"
                                [benefitCategory]="flexibleBenefit.categoryId">
      </app-benefit-availability>

      <div
        class="documents-container"
        *ngIf="
          flexibleBenefit &&
          flexibleBenefit.benefitDocuments &&
          flexibleBenefit.benefitDocuments.length > 0
        "
      >
        <div class="bold dark-green">
          {{ 'FLEXIBLE_FIXED_BENEFITS.REQUIRED_DOCUMENTS' | translate }}
        </div>
        <div class="border-container">
          <a
            *ngFor="
              let flexibleBenefitDocument of flexibleBenefit.benefitDocuments
            "
            href="javascript:void(0)"
            (click)="showDocument(flexibleBenefitDocument)"
            class="document-card"
          >
            <span [ngClass]="'icon-file-text'" class="ficon feather"></span>
            <div class="text-card">
              {{ flexibleBenefitDocument.displayName }}
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="!is24PayBenefit">
      <div *ngIf="flexibleBenefit && benefitTaxes">
        <div class="t-wrapper">
          <div class="taxes">

            <div
              class=" fs-12"
              *ngIf="flexibleBenefit && flexibleBenefit.unitType === UNIT_TYPE.Months">
              {{ 'FLEXIBLE_FIXED_BENEFITS.MONTHLY_PAYMENT' | translate }}
            </div>

            <!-- Payment options the benefit configuration never allows are not rendered at all —
                 showing them disabled with an explanatory tooltip would only be misleading.
                 Card is never combinable with salary, so it is hidden for both salary types;
                 budget is hidden only when salary is the exclusive payment method. -->
            <ng-container *ngIf="!flexibleBenefit.hasSalaryPaymentAllowed()">
              <ng-container *ngIf="flexibleBenefit.hasCreditCardAllowed() && !pendingOrderId; else noCardPayment">
                <div class="d-flex justify-content-end align-items-center mb-1">
                  <label for="card-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_CARD' | translate }}
                  </label>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="card-radio"
                      name="paymentType"
                      [(ngModel)]="selectedPaymentType"
                      value="card"
                      (change)="onPaymentTypeChange()" />
                    <label class="custom-control-label" for="card-radio"></label>
                  </div>
                </div>
              </ng-container>

              <ng-template #noCardPayment>
                <div class="c-title bold mb-1">
                  <label for="card-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_CARD' | translate }}
                  </label>
                  <span
                    placement="auto"
                    ngbTooltip="{{ (pendingOrderId ? 'FLEXIBLE_FIXED_BENEFITS.PAYMENT_PENDING_OR_REFUSED' : 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_CARD_ALLOWED') | translate }}"
                    role="button"
                    tabindex="0"
                    title="{{ (pendingOrderId ? 'FLEXIBLE_FIXED_BENEFITS.PAYMENT_PENDING_OR_REFUSED' : 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_CARD_ALLOWED') | translate }}"
                  >
                  <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="!flexibleBenefit.isSalaryPaymentOnly()">
              <ng-container *ngIf="shouldDisplayBenefitPayment(); else noBenefitPayment">
                <div class="d-flex justify-content-end align-items-center mb-1">
                  <label for="benefit-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_BENEFIT_BUDGET_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
                  </label>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="benefit-radio"
                      name="paymentType"
                      [(ngModel)]="selectedPaymentType"
                      value="benefitBudget"
                      (change)="onPaymentTypeChange()" />
                    <label class="custom-control-label" for="benefit-radio"></label>
                  </div>
                </div>
              </ng-container>

              <ng-template #noBenefitPayment>
                <div class="c-title bold mb-1">
                  <label for="benefit-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_BENEFIT_BUDGET_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
                  </label>
                  <span
                    placement="auto"
                    ngbTooltip="{{ getNoBudgetAvailableToolTip() | translate: {'period': cannotOrderMessagePeriod } }}"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'noBudgetAvailableMessage'"
                  >
                  <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
              </ng-template>
            </ng-container>

            <!-- Salary payment: only rendered for the salary payment types -->
            <ng-container *ngIf="flexibleBenefit.hasSalaryPaymentAllowed()">
              <ng-container *ngIf="shouldDisplaySalaryPayment(); else noSalaryPayment">
                <div class="d-flex justify-content-end align-items-center mb-1">
                  <label for="salary-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_SALARY' | translate }}
                  </label>
                  <div class="custom-control custom-checkbox">
                    <input
                      type="radio"
                      class="custom-control-input"
                      id="salary-radio"
                      name="paymentType"
                      [(ngModel)]="selectedPaymentType"
                      value="salary"
                      (change)="onPaymentTypeChange()" />
                    <label class="custom-control-label" for="salary-radio"></label>
                  </div>
                </div>
              </ng-container>

              <ng-template #noSalaryPayment>
                <div class="c-title bold mb-1">
                  <label for="salary-radio" class="mr-1 bold">
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.WITH_SALARY' | translate }}
                  </label>
                  <span
                    placement="auto"
                    ngbTooltip="{{ getNoSalaryAvailableToolTip() | translate: {'period': cannotOrderMessagePeriod } }}"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'noSalaryAvailableMessage'"
                  >
                  <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
              </ng-template>
            </ng-container>

            <div *ngIf="flexibleBenefit.benefitTypeId !== BenefitType.Insurance" class="bold">
              <ng-container *ngIf="!selectedPaymentType || selectedPaymentType === 'card'; else otherPayment">
                {{ amountWithCamTax | number: '1.0-2' }} RON
              </ng-container>

              <ng-template #otherPayment>
                <ng-container *ngIf="!isLimitExceeded && benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE; else standardTax">
                  {{ amountWithEmployeeAndCamTax | number: '1.0-2' }} RON
                </ng-container>

                <ng-template #standardTax>
                  {{ amountWithCamTax | number: '1.0-2' }} RON
                </ng-template>
              </ng-template>
            </div>

            <div class="semi-bold fs-12 tax-information"  *ngIf="userCompanyInfo.pricingPlan == PricingPlan.FLEX && flexibleBenefit.benefitTypeId !== BenefitType.Insurance">

              <ng-container *ngIf="selectedPaymentType === 'card'">

                <app-tax-category-display
                  class="tax-category-display" category="0">
                </app-tax-category-display>

                <div class="c-title bold"  openDelay="400" >
                    {{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_TAXES_AND_FEES' | translate }}
                    <span
                    placement="auto"
                    ngbTooltip="{{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_TAXES_AND_FEES_TOOLTIP' | translate }}"
                    role="button"
                    tabindex="0"
                    title="{{ 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_TAXES_AND_FEES_TOOLTIP' | translate }}"
                  >
                  <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
                <div *ngIf="hasCamTax" class="c-title bold">
                  {{ benefitTaxes.camTaxValue | number: '1.0-2' }} RON
                  {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
                  <span
                    placement="auto"
                    [ngbTooltip]="camTaxTooltipKey | translate: camTaxTooltipParams"
                    role="button"
                    tabindex="0"
                    [title]="camTaxTooltipKey | translate: camTaxTooltipParams">
                    <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
              </ng-container>
              <ng-container *ngIf="!isLimitExceeded && !isVerifyingOrder && (selectedPaymentType === 'benefitBudget' || selectedPaymentType === 'salary')">
                <ng-container *ngIf="getTaxDisplayInfo() as taxInfo">
                  <app-tax-category-display
                    class="tax-category-display"
                    [category]="taxInfo.taxCategory">
                  </app-tax-category-display>

                  <div *ngIf="taxInfo.showActualBenefitValue" class="c-title bold">
                    <span>
                      {{ taxInfo.amountWithVat | number: '1.0-2' }} RON
                      {{'ACTUAL_BENEFIT_VALUE' | translate}}
                    </span>
                  </div>

                  <div class="c-title bold" openDelay="400">
                    <span *ngIf="taxInfo.taxValue > 0">
                      {{ taxInfo.taxValue | number: '1.0-2' }} RON
                    </span>
                    {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}

                    <span
                      placement="auto"
                      [ngbTooltip]="(taxInfo.shouldShowTaxes ? taxInfo.taxTooltipText : taxInfo.taxTooltipText + '_HIDDEN') | translate"
                      role="button"
                      tabindex="0"
                      [title]="(taxInfo.shouldShowTaxes ? taxInfo.taxTooltipText : taxInfo.taxTooltipText + '_HIDDEN') | translate">
                      <span data-feather="info" [size]="20"></span>
                    </span>
                  </div>

                  <div *ngIf="taxInfo.taxValue > 0" class="c-title bold">
                    {{ 'COMPANY_TAX_DISTRIBUTION.' + taxInfo.taxDistributionTypeName | translate }}
                  </div>

                  <div *ngIf="taxInfo.camTaxValue > 0" class="c-title bold">
                    {{ taxInfo.camTaxValue | number: '1.0-2' }} RON
                    {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
                    <span
                      placement="auto"
                      [ngbTooltip]="taxInfo.camTaxTooltipKey | translate: { percentage: taxInfo.camTaxPercentage }"
                      role="button"
                      tabindex="0"
                      [title]="taxInfo.camTaxTooltipKey | translate: { percentage: taxInfo.camTaxPercentage }">
                      <span data-feather="info" [size]="20"></span>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <div >
              <div
                class=" fs-12"
                *ngIf="flexibleBenefit && flexibleBenefit.unitType === UNIT_TYPE.Months"
              >
                {{ 'FLEXIBLE_FIXED_BENEFITS.FILTER.PERIOD' | translate }}
                {{ flexibleBenefit?.quantity }} Luni
              </div>
            </div>
          </div>

          <ng-container
            *ngIf="flexibleBenefit && flexibleBenefit.unitType === UNIT_TYPE.Units && !isMealTicketBenefit"
          >
            <div class="bold fs-12"></div>
            <div class="quantity-counter-wrapper">
              <core-touchspin
                (open)="quantityChanged($event)"
                [(numberValue)]="selectedQuantity"
                [stepValue]="1"
                [minValue]="minNumberOfUnits"
                [maxValue]="maxNumberOfUnits"
                [disable]="maxNumberOfUnits == 0 || (minNumberOfUnits == maxNumberOfUnits)"
              >
              </core-touchspin>
            </div>
          </ng-container>
          <ng-container
            *ngIf="flexibleBenefit && flexibleBenefit.unitType === UNIT_TYPE.Units && isMealTicketBenefit"
          >
            <div class="quantity-counter-wrapper"  *ngIf="maxNumberOfUnits > 0">
              <app-meal-ticket-selector
                [maxNumberOfUnits]="maxNumberOfUnits"
                [mealTicketsOptions]="mealTicketsOptions"
                [(selectedQuantity)]="selectedQuantity"
                (selectedQuantityChange)="setCurrentMealTicketsNumber($event)"
                ariaLabel="ticketSelectorBenefits"
              ></app-meal-ticket-selector>

              <div class="mealTicketsText fs-12">
                {{'AUTO_ORDER.MEAL_TICKET_INFO' | translate}}
              </div>
            </div>
          </ng-container>
        </div>
        <button
          class="btn btn-primary"
          [disabled]="orderButtonDisabled"
          (click)="goToSummary()"
          ngbTooltip="{{ (selectedPaymentType === '' && canBeOrdered !== false ? 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.SELECT_PAYMENT_METHOD' : '') | translate }}"
          placement="top"
        >
          <span class="ficon icon-arrow-right feather"></span>
          {{ 'FLEXIBLE_FIXED_BENEFITS.BTN_CHOOSE_BENEFIT_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
        </button>

        <app-error-messages
          [errorMessages]="errorMessages">
        </app-error-messages>
      </div>
    </div>

    <div class="right" *ngIf="is24PayBenefit && flexibleBenefit ">
      <div class = "card top">
        <div class="bold dark-green w-top bold text-align-right">
          {{ 'TRANSPORT_24PAY.CONFIGURE_BENEFIT_TITLE' | translate }}
        </div>
        <div class="divider"></div>

        <div>
          {{ 'TRANSPORT_24PAY.COMPANY_LABEL' | translate }}
        </div>

        <select class="margin-top-6" (change)="setSelectedTransportCompany($event.target.value)" title="{{ 'TRANSPORT_24PAY.CHOOSE_COMPANY_OPTION' | translate }}">
          <option [ngValue]="null" hidden selected>{{ 'TRANSPORT_24PAY.CHOOSE_COMPANY_OPTION' | translate }}</option>
          <option *ngFor="let company of flexibleBenefit.responseTransport24Pay.companies" value="{{company.code}}">{{company.name}}</option>
        </select>

        <div class="margin-top-16">
          {{ 'TRANSPORT_24PAY.TICKET_LABEL' | translate }}
        </div>
        <select class="margin-top-6" (change)="setSelectedTransportTicket($event.target.value)" title="{{ 'TRANSPORT_24PAY.CHOOSE_TICKET_OPTION' | translate }}">
          <option [ngValue]="null" hidden selected>{{ 'TRANSPORT_24PAY.CHOOSE_TICKET_OPTION' | translate }}</option>
          <ng-container *ngIf="selectedCompany24Pay && transport24PayTickets">
            <option *ngFor="let tickets of transport24PayTickets" value="{{tickets.id}}">{{tickets.name}}</option>
          </ng-container>
        </select>
      </div>



      <div class = "card bottom">
        <div class="bold dark-green w-top text-align-right">
          <div *ngIf="!(selectedCompany24Pay && selectedTicket24Pay && benefitTaxes.amountWithVat > 0)">
            {{ 'TRANSPORT_24PAY.CHOOSE_TICKET_TITLE' | translate }}

            <div class="semi-bold fs-12 tax-information">
              <app-tax-category-display class="tax-category-display" category="{{flexibleBenefit.benefitTaxCategory}}"></app-tax-category-display>

              <div class="c-title bold"  openDelay="400" >
                  {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}
              </div>


              <div *ngIf="benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE_SALARY && benefitTaxes.employeeTaxValue !== 0" class="c-title bold">
                {{ 'COMPANY_TAX_DISTRIBUTION.EMPLOYEE_SALARY' | translate }}
              </div>
              <div *ngIf="benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE && benefitTaxes.companyTaxValue !== 0" class="c-title bold">
                {{ 'COMPANY_TAX_DISTRIBUTION.COMPANY' | translate }}
              </div>
              <div *ngIf="benefitTaxes.taxDistributionType === CompanyTaxDistribution.COMPANY && benefitTaxes.companyTaxValue !== 0" class="c-title bold">
                {{ 'COMPANY_TAX_DISTRIBUTION.COMPANY' | translate }}
              </div>

              <div *ngIf="hasCamTax" class="c-title bold">
                {{ benefitTaxes.camTaxValue | number: '1.0-2' }} RON
                {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
                <span
                  placement="auto"
                  [ngbTooltip]="camTaxTooltipKey | translate: camTaxTooltipParams"
                  role="button"
                  tabindex="0"
                  [title]="camTaxTooltipKey | translate: camTaxTooltipParams">
                  <span data-feather="info" [size]="20"></span>
                </span>
              </div>
            </div>
          </div>


          <div *ngIf="selectedCompany24Pay && selectedTicket24Pay && amountWithCamTax > 0">
            <div *ngIf="benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE_SALARY || benefitTaxes.taxDistributionType === CompanyTaxDistribution.COMPANY"
              class="bold">{{ amountWithCamTax | number: '1.0-2'}} RON</div>
            <div *ngIf="benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE"
              class="bold">{{ amountWithEmployeeAndCamTax | number: '1.0-2'}} RON</div>

            <ng-container *ngIf="getTaxDisplayInfo() as taxInfo">
              <div class="semi-bold fs-12 tax-information">
                <app-tax-category-display
                  class="tax-category-display"
                  [category]="taxInfo.taxCategory">
                </app-tax-category-display>

                <div class="c-title bold" openDelay="400">
                  <span *ngIf="taxInfo.taxValue > 0">
                    {{ taxInfo.taxValue | number: '1.0-2' }} RON
                  </span>
                  {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.TAXES_AND_FEES' | translate }}

                  <span
                    placement="auto"
                    [ngbTooltip]="taxInfo.taxTooltipText | translate"
                    role="button"
                    tabindex="0"
                    [title]="taxInfo.taxTooltipText | translate">
                    <span data-feather="info" [size]="20"></span>
                  </span>
                </div>

                <div *ngIf="taxInfo.taxValue > 0" class="c-title bold">
                  {{ 'COMPANY_TAX_DISTRIBUTION.' + taxInfo.taxDistributionTypeName | translate }}
                </div>

                <div *ngIf="taxInfo.camTaxValue > 0" class="c-title bold">
                  {{ taxInfo.camTaxValue | number: '1.0-2' }} RON
                  {{ 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_WITHHELD_FROM_BENEFITS_BUDGET' | translate }}
                  <span
                    placement="auto"
                    [ngbTooltip]="taxInfo.camTaxTooltipKey | translate: { percentage: taxInfo.camTaxPercentage }"
                    role="button"
                    tabindex="0"
                    [title]="taxInfo.camTaxTooltipKey | translate: { percentage: taxInfo.camTaxPercentage }">
                    <span data-feather="info" [size]="20"></span>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="divider"></div>
        <div >
          <button
          class="btn btn-primary"
          [disabled]="isOrderButtonDisabled"
          (click)="goToSummary()">
            <span class="ficon icon-arrow-right feather"></span>
            {{ 'FLEXIBLE_FIXED_BENEFITS.BTN_CHOOSE_BENEFIT_' + PRICING_PLAN_LABEL[userCompanyInfo.pricingPlan] | translate }}
          </button>

          <app-error-messages
            [errorMessages]="errorMessages"
            [extraClass]="'text-center'">
          </app-error-messages>
        </div>
      </div>
    </div>
  </div>

  <ng-template #budgetExceededError>
    <div class="not-eligible-warning font-small-3 mt-2">
      <div class="d-flex align-items-center justify-content-center">
        <span class="mr-1">
          {{ 'FLEXIBLE_FIXED_BENEFITS.BUDGET_EXCEDEED' | translate }}
        </span>
        <span
          placement="auto"
          [ngbTooltip]="tooltipTemplate"
          [openDelay]="200"
          [closeDelay]="100"
          container="body"
          role="button"
          tabindex="0"
          class="info-icon"
        >
          <span data-feather="alert-circle" [size]="20"></span>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #tooltipTemplate>
    <div class="tooltip-content">
      <div class="tooltip-title">
        <strong>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.TITLE' | translate }}</strong>
      </div>
      <p>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.DESCRIPTION' | translate }}</p>
      <ol>
        <li>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.BUDGET_ORDER.GENERAL' | translate }}</li>
        <li>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.BUDGET_ORDER.TRANSPORT' | translate }}</li>
        <li>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.BUDGET_ORDER.PROFESSIONALDEVELOPMENT' | translate }}</li>
        <li>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.BUDGET_ORDER.CASHBACK' | translate }}</li>
        <li>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.BUDGET_ORDER.CARD' | translate }}</li>
      </ol>
      <div class="tooltip-important">
        <strong>{{ 'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.IMPORTANT_TITLE' | translate }}</strong>
      </div>
      <ul>
        <li [innerHTML]="'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.IMPORTANT.NO_CARD_PAYMENT' | translate"></li>
        <li [innerHTML]="'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.IMPORTANT.PAYMENT_RULES' | translate"></li>
        <li [innerHTML]="'FLEXIBLE_FIXED_BENEFITS.TOOLTIP.IMPORTANT.TAX_EXEMPT' | translate"></li>
      </ul>
    </div>
  </ng-template>

  <!-- OTHER BENEFITS FROM THE SAME SUPPLIER -->
  <div class="offers" *ngIf="!is24PayBenefit && cards && cards.length > 0 && flexibleBenefit">
    <h3 class="bold dark-green">
      {{ 'FLEXIBLE_FIXED_BENEFITS.OTHER_BENEFITS' | translate }}
      {{
        flexibleBenefit.unitType !== UNIT_TYPE.Units
          ? flexibleBenefit?.providerName
          : ''
      }}
    </h3>
    <div class="medical-cards" *ngIf="cards.length > 0">
      <ng-container #customOffers>
        <div class="d-flex customOffers">
          <div
            class="card clickable"
            *ngFor="let card of cards"
            (click)="goToOtherOffer(card.id)"
          >
            <div *ngIf="card.discountPercentage" class="discount-badge">
              <span class="badge-text">-{{ card.discountPercentage }}%</span>
            </div>
            <div class="image">
              <img [src]="card.pictureUrl" alt="" role="presentation" height="100" class="img img-fluid" />
            </div>
            <div class="b-card">
              <div class="bold">{{ card.name }}</div>
              <div class="dark-green semi-bold">
                {{ card.price }} RON
                <span *ngIf="card.discountPercentage" class="old-price">
                  {{ card.price / (100 - card.discountPercentage) * 100 | number:'1.2-2' }} RON
                </span>
                <span class="text-lowercase" *ngIf="ACQUISITION_TYPE.Subscription == card.acquisitionType">
                  /{{ 'MONTH' | translate }}
                </span>
              </div>
              <a href="javascript:void(0)" class="card-link semi-bold c-company"
                >{{ 'FLEXIBLE_FIXED_BENEFITS.VIEW' | translate }}
                {{ 'FLEXIBLE_FIXED_BENEFITS.TEXT_OFFER' | translate }}
                <span class="ficon icon-chevron-right feather"></span>
              </a>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
